import { css } from 'styled-components';
import { paletteHelper } from '@property.com.au/ui-kit';

export const getFeatureButtonStyle = () => css`
  background: linear-gradient(
    75deg,
    rgba(228, 0, 43, 1) 0%,
    rgba(136, 0, 178, 1) 51%,
    rgba(228, 0, 43, 1) 100%
  );
  background-size: 200% auto;
  transition: background-position 0.75s;
  color: ${paletteHelper('textInvertedStatic')};
  border: none;

  &:hover {
    background-position: right center;
    color: ${paletteHelper('textInvertedStatic')};
    border: none;
  }

  &:active {
    background: ${paletteHelper('backgroundPressedBrandStatic')};
  }

  &:focus {
    color: ${paletteHelper('textInvertedStatic')};
    border: ${paletteHelper('borderFocused')};
  }
`;

export const applyFeatureButtonStyle = (className: string) => css`
  .${className} {
    background: linear-gradient(
      75deg,
      rgba(228, 0, 43, 1) 0%,
      rgba(136, 0, 178, 1) 51%,
      rgba(228, 0, 43, 1) 100%
    );
    background-size: 200% auto;
    transition: background-position 0.75s;
    color: ${paletteHelper('textInvertedStatic')};
    border: none;
  }

  &:hover .${className} {
    background-position: right center;
    color: ${paletteHelper('textInvertedStatic')};
    border: none;
  }

  &:active .${className} {
    background: ${paletteHelper('backgroundPressedBrandStatic')};
  }

  &:focus .${className} {
    color: ${paletteHelper('textInvertedStatic')};
    border: ${paletteHelper('borderFocused')};
  }
`;
